"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "baceno": {
    "a3941a1c": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "skipSearch": false
    }],
    "corbenas": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "703a61b7": [{
      "hkey": "0cacb44e",
      "slug": "devero-ai-ponti",
      "name": "Devero-Ai Ponti",
      "primary": true,
      "skipSearch": false
    }],
    "devero": [{
      "hkey": "0cacb44e",
      "slug": "devero-ai-ponti",
      "name": "Devero-Ai Ponti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "31de0262": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "skipSearch": false
    }],
    "esigo": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fe81677c": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "skipSearch": false
    }],
    "fontane": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8fdcdeeb": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "skipSearch": false
    }],
    "forno": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1dcba0b3": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "skipSearch": false
    }],
    "goglio": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "89c19a4f": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "skipSearch": false
    }],
    "misanco": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b717ebee": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "skipSearch": false
    }],
    "montepiano": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b8255997": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-romano": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a36e31d2": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "skipSearch": false
    }],
    "sangiatto": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8bffb26a": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "skipSearch": false
    }],
    "verampio": [{
      "hkey": "b3c80afe",
      "slug": "baceno",
      "name": "Baceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;